import { Sandpack } from "@codesandbox/sandpack-react";

const PaginationApi = () => {
  const code = `
import React from "react";
import { ReactUtilityTable } from "react-utility-table";

export default function App() {
  return (
    <div>
      <ReactUtilityTable          
        columns={[
          {
            title: "Name",
            render: rowData => rowData.name.first + " " + rowData.name.last
          },
          {
            title: "Email",
            field: "email"
          },
          {
            title: "Avatar",
            render: rowData => (
              <img
                style={{ height: 36, borderRadius: '50%' }}
                src={rowData.picture.thumbnail}
                alt="avatar"
              />
            )
          }
        ]}
        queryData={(query) =>
          new Promise(async (resolve, reject) => {
            try {
              let url = "https://randomuser.me/api/?results=";
              url += query.pageSize;
              url += "&page=" + query.page;

              const response = await fetch(url);
              const result = await response.json();

              resolve({
                totalCount: 100, // simulated total
                data: result.results
              });
            } catch (error) {
              reject(error);
            }
          })
        }
        options={{
          pageSize: 5,
          globalSearch: false,
        }}
      />
    </div>
  );
}
`;

  return (
    <div>
      <p style={{ margin: "5px 0px" }}>
        <strong>PlayGround for editable: </strong>
        <br /><br />
      </p>

      <Sandpack
        template="react"
        files={{
          "/App.js": code,
        }}
        customSetup={{
          dependencies: {
            react: "18.0.0",
            "react-dom": "18.0.0",
            "react-scripts": "5.0.1",
            "react-utility-table": "2.1.5",
          },
        }}
        theme="dark"
        options={{
          showLineNumbers: true,
          editorHeight: 500,
        }}
      />
    </div>
  );
};


export default PaginationApi;
